<!--
* @description  参数1
* @fileName  actionIndex
* @author userName
* @date 2024-01-19 15:53:28
!-->
<template>
  <div>
    <div class="group-main">
      <div class="group-main-aside">
        <ul>
          <li
            v-for="(item,index) in ulList"
            :key="index"
            :class="{ selected_li: selectedIndex === index }"
            @click="selectItem(index)"
          >
            {{ item.text }}
          </li>
        </ul>
      </div>
      <div class="group-main-container">
        <SendReceive v-show="selectedIndex == 0" ref="sendReceiveRef" @submitForm="handleFormSubmit" />
        <GoodsInfo v-show="selectedIndex == 1" ref="goodsInfoRef" @submitForm="handleFormSubmit" />
        <AdditionService v-show="selectedIndex == 2" ref="additionServiceRef" @submitForm="handleFormSubmit" />
        <!-- 底部信息 -->
        <div class="bottom-info">
          <div class="bottom-info-left">
            <div class="flex bottom-row-info">
              <div class="text1">总重量：<span class="text2">{{ placeOrderData.weight }}KG</span></div>
              <div class="text1">总体积：<span class="text2">{{ placeOrderData.volume }}CBM</span></div>
              <div class="text1">总件数：<span class="text2">{{ placeOrderData.quantity }}件</span></div>
              <div class="text1 flex" style="width: 100%;">
                <span>货物类型：</span>
                <span
                  class="text2 cargoTypeName"
                  :title="placeOrderData.cargoTypeNames"
                >{{ placeOrderData.cargoTypeNames }}</span>
              </div>
            </div>
            <el-popover placement="top-start" width="200" trigger="hover">
              <!-- 运费信息 -->
              <div class="freight-info">
                <div class="detail-row">
                  <span>运费单价</span>
                  <span
                    v-if="fbaCalculation.totalAmount > 0"
                  >￥{{ (fbaCalculation.totalAmount/fbaCalculation.chargeWeight).toFixed(2) }}/{{ getUnit(fbaCalculation.countMode) }}</span>
                </div>
                <div class="detail-row">
                  <span>计费重</span>
                  <span>{{ fbaCalculation.chargeWeight }}
                    {{ getUnit(fbaCalculation.countMode) }}</span>
                </div>
                <div class="detail-row-line" />
                <div v-if="fbaCalculation.pickupAmount > 0" class="detail-row">
                  <span>Pickup Fee</span>
                  <span>￥{{ fbaCalculation.pickupAmount }}</span>
                </div>
                <div v-if="fbaCalculation.startLiftgateAmount > 0" class="detail-row">
                  <span>Flat Fee</span>
                  <span>￥{{ fbaCalculation.startLiftgateAmount }}</span>
                </div>
                <div v-for="(item,index) in fbaCalculation.feeList" :key="index" class="detail-row">
                  <span>{{ item.feeName }}</span>
                  <span v-if="item.totalAmount>0">￥{{ item.totalAmount }}</span>
                  <span v-else>单询</span>
                </div>
                <div v-if="fbaCalculation.bondAmount > 0" class="detail-row">
                  <span>Annual bond</span>
                  <span>￥{{ fbaCalculation.bondAmount }}</span>
                </div>
                <div v-if="fbaCalculation.destLiftgateAmount > 0" class="detail-row">
                  <span>Lift Gate Charge</span>
                  <span>￥{{ fbaCalculation.destLiftgateAmount }}</span>
                </div>
                <div v-if="fbaCalculation.ISFBondAmount > 0" class="detail-row">
                  <span>ISF Bond</span>
                  <span>￥{{ fbaCalculation.ISFBondAmount }}</span>
                </div>
                <div v-if="fbaCalculation.insuranceAmount > 0" class="detail-row">
                  <span>保险费 (货值：${{ fbaCalculation.GoodsValue }})</span>
                  <span>￥{{ fbaCalculation.insuranceAmount }}</span>
                </div>
              </div>
              <div slot="reference" class="bottom-row-cost">
                <span class="cost-label">预估费用：</span>
                <span class="cost-amount">
                  <span
                    v-if="fbaCalculation.totalAmount > 0"
                  >￥{{ fbaCalculation.totalAmount.toFixed(2) }}</span>
                  <img
                    class="margin-left_5"
                    src="@/assets/img/client/booking/up-arrows.png"
                    width="12"
                    height="6"
                  >
                </span>
              </div>
            </el-popover>
            <button class="place-order" @click="placeOrder">{{ data.status==1?'下单':'保存' }}</button>
          </div>

        </div>
      </div>
    </div>
    <CancelShipment ref="cancelSh" @confirm="finish" />
  </div>
</template>

<script>
import ByFold from '../../../../../../components/byFold/byFold.vue'
import BillingDetails from './billingDetails.vue'
import ContactIndex from './contactDetails/contactIndex.vue'
import Commodities from './yourGoods/commodities.vue'
import Invoice from './yourGoods/invoice.vue'
import POA from './yourGoods/poa.vue'
import CancelShipment from './cancelShipment.vue'
import SendReceive from './yourGoods/sendReceive.vue'
import GoodsInfo from './yourGoods/goodsInfo.vue'
import AdditionService from './yourGoods/additionService.vue'
import {
  CheckOrderCompleteDetail
} from '@/api/order.js'
import {
  getCookie
} from '@/utils/cookiejs'
import request from '@/utils/request'
export default {
  name: 'ActionIndex',
  components: {
    // 组件的引用
    ByFold,
    BillingDetails,
    ContactIndex,
    Commodities,
    Invoice,
    POA,
    SendReceive,
    GoodsInfo,
    AdditionService,
    CancelShipment
  },
  props: {
    // 父辈向子辈传参

  },
  data() {
    return {
      isCancelDialog: false,
      data: {
        chargeWeight: 0,
        totalAmount: 0
      },
      selectedIndex: 0,
      ulList: [{
        text: '收发信息',
        value: 1
      },
      {
        text: '货物信息',
        value: 2
      },
      {
        text: '附加服务',
        value: 3
      }
      ],
      menuList: [{
        name: '付款',
        isTrue: false,
        child: [{
          name: '付款方式',
          isActive: false
        }]
      },
      // {
      //   name: '联系方式',
      //   isTrue: false,
      //   child: [{
      //     name: '发件人地址',
      //     isActive: false
      //   },
      //   {
      //     name: '收件人地址',
      //     isActive: false
      //   }
      //   ]
      // },
      {
        name: '货物信息',
        isTrue: false,
        child: [{
          name: '文件上传',
          isActive: false
        }]
      },
      {
        name: '报关文件',
        isTrue: false,
        child: [{
          name: 'POA',
          isActive: false
        }]
      }
      ],
      activeName: '',
      fbaCalculation: {},
      allFormData: {},
      placeOrderData: {}
    }
  },
  computed: {

    // 计算属性
    showContact() {
      return ['取件地址', '发件人地址', '派送地址', '收件人地址'].some(
        (item) => this.activeName == item
      )
    }
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
  },
  mounted() {
    // 页面进入时加载内容
  },
  beforeDestroy() {
    // 组件销毁前移除事件监听
  },
  methods: {
    scrollToTop() {
      // 直接访问父组件并调用其方法
      this.$parent.scrollToTop()
    },
    getUnit(countMode) {
      switch (countMode) {
        case 1:
        case 2:
          return 'KG'
        case 3:
          return 'CBM'
        default:
          return ''
      }
    },
    nextStep(index) {
      this.selectedIndex = index
    },
    recoveryScroll() {
      this.$parent.recoveryScroll()
    },
    selectItem(index) {
      this.selectedIndex = index
    },
    next(stepName, index) {
      this.activeName = stepName
      this.getActive({
        name: stepName,
        isActive: false
      }, index)
      this.menuList.forEach((item, index) => {
        item.child.forEach((item1, index1) => {
          if (item1.name === stepName) {
            this.isOpen(item, index)
            this.getActive(item1, index1)
          }
        })
      })
      this.checkOrder()
    },
    checkOrder() {
      CheckOrderCompleteDetail(this.data.orderNo).then(res => {
        if (res.code === 200) {
          var completeList = res.data.completeList
          var incompleteList = res.data.incompleteList
          completeList.forEach(stepName => {
            this.menuList.forEach((item, index) => {
              item.child.forEach((item1, index1) => {
                if (item1.name === stepName) {
                  item1.isFinish = true
                }
              })
            })
          })
          incompleteList.forEach(stepName => {
            this.menuList.forEach((item, index) => {
              item.child.forEach((item1, index1) => {
                if (item1.name === stepName) {
                  item1.isFinish = false
                }
              })
            })
          })
        }
      })
    },
    cancelShip() {
      this.$refs.cancelSh.init(this.data)
    },
    finish() {
      this.$emit('finish')
    },
    init(data) {
      this.data = data
      this.placeOrderData = data
      this.$refs.sendReceiveRef.init(data)
      this.$refs.goodsInfoRef.init(data)
      this.$refs.additionServiceRef.init(data)
      this.checkOrder()
      this.getFbaCalculation()
    },
    // 方法
    isOpen(item, index) {
      this.menuList.forEach((res, i) => {
        if (index == i) {
          this.$set(res, 'isTrue', true)
        } else {
          this.$set(res, 'isTrue', false)
        }
      })
    },
    getActive(item, index) {
      this.activeName = item.name
      if (this.activeName === '付款方式') {
        this.$nextTick(() => {
          this.$refs.BillingDetails.init(this.data)
        })
      }
      if (['取件地址', '发件人地址', '派送地址', '收件人地址'].some((item) => this.activeName == item)) {
        this.$nextTick(() => {
          this.$refs.ContactIndex.init(this.data, index)
        })
      }
      if (this.activeName === '货物信息') {
        this.$nextTick(() => {
          this.$refs.Commodities.init(this.data)
        })
      }
      if (this.activeName === '文件上传') {
        this.$nextTick(() => {
          this.$refs.Invoice.init(this.data)
        })
      }
      if (this.activeName === 'POA') {
        this.$nextTick(() => {
          this.$refs.POA.init(this.data)
        })
      }
      this.menuList.forEach(res => {
        res.child.forEach((list, j) => {
          if (index == j) {
            this.$set(list, 'isActive', true)
          } else {
            this.$set(list, 'isActive', false)
          }
        })
      })
    },
    handleFormSubmit(formData) {
      this.allFormData = {
        ...this.allFormData,
        ...formData
      }
    },
    queryPrice() {
      var volumeCargoErr = false
      this.allFormData.volumeCargoList.forEach(item => {
        if (!item.weight || !item.length || !item.width || !item.height || !item.quantity) {
          volumeCargoErr = true
        }
      })
      if (volumeCargoErr || this.allFormData.volumeCargoList.length === 0) {
        return
      } else {
        var totalWeight = 0
        var totalQuantity = 0
        var totalVolume = 0
        this.allFormData.volumeCargoList.forEach(item => {
          if (item.weight) {
            totalWeight += parseFloat(item.weight)
          }
          if (item.quantity) {
            totalQuantity += parseInt(item.quantity)
          }
          if (item.length && item.width && item.height) {
            totalVolume += parseFloat(item.length) * parseFloat(item.width) * parseFloat(item
              .height) / 1000000
          }
        })
        this.placeOrderData.quantity = totalQuantity
        this.placeOrderData.weight = totalWeight
        this.placeOrderData.volume = totalVolume.toFixed(2)
        this.getFbaCalculation()
      }
    },
    getFbaCalculation() {
      request({
        url: `/api/shipping/fbaCalculation`,
        method: 'post',
        headers: {
          'Authorization': getCookie('token')
        },
        data: this.placeOrderData
      }).then(res => {
        this.fbaCalculation = res.data[0]
      })
    },
    async placeOrder() {
      const isSendReceiveValid = await this.$refs.sendReceiveRef.validateForm()
      if (!isSendReceiveValid) {
        this.selectedIndex = 0
        return
      }

      const isGoodsInfoValid = await this.$refs.goodsInfoRef.validateForm()
      if (!isGoodsInfoValid) {
        this.selectedIndex = 1
        return
      }

      const isAdditionServiceRefValid = await this.$refs.additionServiceRef.validateForm()
      if (!isAdditionServiceRefValid) {
        this.selectedIndex = 2
        return
      }

      if (isSendReceiveValid && isGoodsInfoValid && isAdditionServiceRefValid) {
        this.$parent.setLoading(true)

        this.placeOrderData.orderCreateType = 2
        const placeOrderData = {
          ...this.placeOrderData,
          ...this.allFormData
        }

        request({
          url: `/api/shipping/FbaOrder`,
          method: 'put',
          headers: {
            'Authorization': getCookie('token')
          },
          data: placeOrderData
        }).then(res => {
          this.$nextTick(() => {
            this.$parent.initOrder(this.placeOrderData.orderNo)
            if (res.code == 200) {
              this.$message({
				  message: '操作成功',
				  type: 'success',
				  duration: 1000
              })
            }
          })
        }).finally(() => {
          this.$parent.setLoading(false)
        })
      }
    }
  }
}
</script>
<style scoped lang='scss'>
	.confirmOrder-title-font {
		font-size: 18px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 600;
		color: #333333;
	}

	.actionIndex {
		width: 1168px;
		height: 140px;
		background: #FFFFFF;
		border-radius: 8px;
		padding: 16px;
		margin-top: 16px;

		.card-bg {
			display: block;
			text-align: center;
			width: 1168px;
			height: 56px;
			background: url("../../../../../../assets/img/client/booking/bg_xiadan.png");
			background-size: 1168px 100px;
			padding: 22px 0;

			div:nth-of-type(1) {
				@extend .confirmOrder-title-font;
				margin-bottom: 11px;
			}

			div:nth-of-type(2) {
				font-size: 14px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				color: #777777;
			}
		}

		.card-default {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin: 17px 0;

			.card-l {
				display: flex;
				font-size: 16px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 600;
				color: #333333;

				img {
					margin-right: 8px;
				}
			}

			.card-r {
				font-size: 14px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				color: #027FFC;
				cursor: pointer;
			}
		}

	}

	.group-main {
		display: flex;
		margin: 16px 0;

		.group-main-aside {
			width: 200px;
			height: auto;
			border-radius: 8px;
			background: #fff;
			margin-right: 5px;

			ul {
				list-style: none;
				padding-left: 0;
				width: 150px;
				margin: 20px auto;

				li {
					position: relative;
					padding: 8px 0;
					cursor: pointer;
					font-size: 14px;
					font-weight: 500;
				}

				li::before {
					content: "•";
					color: #818181;
					font-size: 40px;
					position: absolute;
					left: 25px;
					top: -4.5px;
				}

				.selected_li {
					background: #F1F5FF;
					border-radius: 6px;
					color: #3370FF;

				}

				.selected_li::before {
					color: #3370FF;
				}
			}

		}

		.group-main-container {
			width: 1000px;
			height: auto;

			.bottom-info {
				margin-top: 5px;
				padding: 20px;
				display: flex;
				border-radius: 8px;
				background: #FFFFFF;

				.bottom-info-left {
					width: 100%;
					display: flex;
					justify-content: space-between;

					::v-deep .el-popover__reference-wrapper {
						height: 100%;
					}

					.text1 {
						color: #777777;
						font-size: 14px;
					}

					.text2 {
						color: #333333;
						font-size: 14px;
					}

					.bottom-row-info {
						width: 500px;
						flex-wrap: wrap;
						text-align: left;
						font-size: 14px;

						div {
							width: 150px;
						}

						div:nth-child(4) {
							line-height: 27px;
						}

						.cargoTypeName {
							width: 80%;
							display: -webkit-box;
							-webkit-line-clamp: 1;
							/* 限制显示行数 */
							-webkit-box-orient: vertical;
							overflow: hidden;
							text-overflow: ellipsis;
						}
					}

					.bottom-row-cost {
						height: 100%;
						display: flex;
						align-items: center;
						justify-items: center;
						font-size: 16px;
						font-weight: bold;
						cursor: pointer;

						.cost-amount {
							color: #FF6C00;
							font-size: 18px;
							display: flex;
							justify-content: center;
							align-items: center;
						}

					}

					.place-order {
						width: 160px;
						height: 50px;
						font-size: 18px;
						background-color: #007BFF;
						color: white;
						border: none;
						border-radius: 3px;
						cursor: pointer;
					}
				}

			}
		}
	}

	.freight-info {
		background: #FFFFFF;
		border-radius: 10px;
		font-size: 14px;
		color: #333333;
		font-weight: 400;

		.detail-row-line {
			flex: 1;
			height: 1px;
			border-top: 1px dashed #dddddd;
			margin: 5px 0;
		}

		.detail-row {
			display: flex;
			justify-content: space-between;
		}
	}
</style>
